import { Stack, Typography } from '@mui/joy'
import { useStore } from 'effector-react'
import { ParseKeys } from 'i18next'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { driverModel } from '~/entities/common/Driver'
import { getDeclension } from '~/shared/lib/utils'
import { ChipStatus } from '~/shared/ui/Chips'

export function ExperienceDays() {
  const { t } = useTranslation()

  const isLoading = useStore(driverModel.experienceDaysFx.pending)
  const experienceDays = useStore(driverModel.$experienceDays) || 0

  const label = useMemo(() => {
    const prefix = `${getDeclension(experienceDays, [
      'day one',
      'day few',
      'day many',
    ])}` as ParseKeys
    return t(prefix, { days: experienceDays })
  }, [experienceDays, t])

  if (isLoading) return null

  return (
    <Stack
      data-testid='experience-days'
      direction='row'
      alignItems='center'
      spacing={1}
    >
      <Typography fontSize={12}>{t('work experience')}</Typography>

      <ChipStatus variant={experienceDays ? 'purple' : 'gray'} label={label} />
    </Stack>
  )
}
